export default "__VITE_ASSET__1941f3ab__"